const styles = {
  link: {
    color: "white",
  },
};
export default styles;
